<script>
import CounterButton from '@/components/inputs/buttons/CounterButton.vue'
import { mapGetters } from 'vuex';

export default {
  name: "SpotjesCard",
  components: {
    CounterButton
  },

  props: {
    spotje: Object,
    cardIndex: Number,
  },

  emits: ['select', 'updateArticle'],

  data () {
    return {
      models: import.meta.env.VITE_VUE_APP_MODELS_LOCATION,
      previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
      currentColorIndex: 0,
      currentColorCode: '',
      allowUpdate: true,
      specsVisible: false,
      hasGlowingInfoBtn: false,
      hasGlowingCloseBtn: false,
    }
  },

  computed: {
    ...mapGetters({
      infoboxes: 'getInfoboxes', 
    }),
  },

  mounted() {
    // console.log('spotje', this.spotje)
    this.currentColorCode = this.spotje.colors[0].code;
  },

  methods: {
      handleColorClick(colorIndex) {
        // console.log('handleColorClick(colorindex)',colorIndex)
        this.allowUpdate = false;
        this.currentColorIndex = colorIndex;
        this.currentColorCode = this.spotje.colors[colorIndex].code;
        setTimeout(() => {
          this.allowUpdate = true;
        }, 100);
        // this.$emit('select', {code: this.currentColorCode, colorIndex: colorIndex, cardIndex: this.index,});
      },
      updateArticle(counter) {
        // console.log('SpotjesCard updateArticle', counter)
        if (this.allowUpdate && this.currentColorCode) {
          this.$emit('updateArticle', { 
            counter: counter, 
            cardIndex: this.cardIndex, 
            colorIndex: this.currentColorIndex,
            code: this.currentColorCode });
          }
        },
      specsBtnMouseOver() {
        this.hasGlowingInfoBtn = true;
      },
      specsBtnMouseLeave(){
        this.hasGlowingInfoBtn = false;
      },
      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
      }
    },
}
</script>

<template>
  <section id="cardwrapper">
    <div class="card">
      <div class="card-header">
        <img 
          :src="`${previewsServer + models}previews/${spotje.colors[currentColorIndex].code}.png`" 
          :alt="spotje.code"
          @error="setBackupImage($event, data)"
        >

        <!-- COLORS -->
        <section style="display: flex;">
          <div
            v-if="spotje.colors"
            class="card-header-colors"
          >
            <div 
              v-for="(_, i) in spotje.colors" 
              :key="i"
              class="card-header-colors-cntdisplay"
              :class="(i === currentColorIndex && spotje.colors[i]?.counter > 0) ? 'card-header-colors-cntdisplay-active' : ''"
            >
              {{ spotje.colors[i].counter ? `${spotje.colors[i].counter}x` : '' }}
            </div>
          </div>
          <div 
            v-if="spotje.colors"
            class="card-header-colors" 
          >
            <button 
              v-for="(color, i) in spotje.colors" 
              :key="i" 
              class="card-header-colors-button" 
              :title="`${color.name} (${color.code})`"
              :style="`background-color: ${color.hexCode};`"
              :class="i === currentColorIndex ? 'card-header-colors-button-active' : ''"
              @click="handleColorClick(i)"
            >
              <span>{{ color.name }}</span>
            </button>
          </div>
        </section>
      </div>

      <!-- CARD INFO -->
      <div class="card-info">
        <div class="card-info-header">
          <h3>{{ spotje.shortName }}</h3>
          <div class="infobox" v-if="spotje.infoboxOnline">
            <button 
              class="infobox-button-specs" 
              @mouseover="specsBtnMouseOver" 
              @mouseleave="specsBtnMouseLeave"
              @click.stop="enableAndHoldSpecs()"
            >
              <div class="infobox-question-mark" style="pointer-events: none;">?</div>
              <span class="infobox-button-specs-text">
                Meer info
              </span>
            </button>
          </div>
        </div>
        <span>{{ spotje.description }}</span>
    </div>

      <!-- COUNT -->
      <div class="card-info-counter">
        <!-- <CounterButton style="max-width: 125px;" @update="updateCounter" :value="data.counter" /> -->
        <CounterButton 
          v-if="spotje.colors[currentColorIndex]"
          style="max-width: 125px;" 
          :value="spotje.colors[currentColorIndex].counter" 
          @update="updateArticle($event)"
        />
      </div>
    </div>
  </section>





  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcover"
        @click="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
            <button 
              class="modalclosebutton" 
              @mouseover="specsCloseBtnMouseOver" 
              @mouseleave="specsCloseBtnMouseLeave"
              @click="specsVisible = false"
            >
              <Transition name="closebtn">
                <div 
                  v-show="hasGlowingCloseBtn"
                  class="absolutepos glowingclose"
                />
              </Transition>
              <div>
                ×
              </div>
            </button>
          <!-- <div class="greyheader"> 
            {{ data.infobox.header }}
          </div> -->
          <div class="imagescroller">
            <img class="modalimage" :src="`/infoboximages/${infoboxes.find(info => info.id === spotje.infobox)?.urlEnding}`" alt="">
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>

</template>

<style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  height: calc(100% - 20px);
  flex-direction: column;
  outline: 2px solid $c-border-1;
  border-radius: $radius-m;
  padding: 10px;
  transition: outline-color 100ms ease;
  border: none;
  background-color: transparent;
  scroll-margin: 150px;

  &:hover {
    outline-color: $c-secondary;
    cursor: pointer;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    height: 150px;
    max-width: 100%;

    & img {
      min-height: 150px;
      max-height: 150px;
      width: calc(100% - 24px);
      object-fit: contain;
    }

    &-colors {
      display: flex;
      flex-direction: column;
      gap: 8px;

      &-button {
        min-height: 32px;
        min-width: 32px;
        border: 2px solid $c-border-1;
        box-sizing: border-box;
        border-radius: $radius-m;
        transition: border 100ms ease;
        position: relative;
        cursor: pointer;
        margin-bottom: 16px;

        &:hover {
          border-color: $c-secondary;
        }

        &-active {
          border: 4px solid $c-secondary;
        }

        & span {
          font-size: 9px;
          position:absolute;
          top: calc(100% + 4px);;
          left: 50%;
          transform: translateX(-50%);
          width: 200%;
        }
      }

      &-cntdisplay {
        height: 32px;
        width: 32px;
        margin-bottom: 13px;
        // outline: 3px solid $c-border-1;
        // outline-offset: -2px;
        border: none;
        border-radius: $radius-s;

        &-active {
          // color: $c-secondary;
          font-weight:bolder;
        }
      }
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;

    min-height: 2.8rem;

    &-header {
      display: flex;
      width: 100%;
    }

    & h3 {
      font-size: 19px;
      font-family: 'Oswald', sans-serif;
      text-transform: uppercase;
      font-weight: 700;
      text-align: left;
    }

    & span {
      font-weight: 400;
      text-align: left;
    }

    &-size {
      display: flex;
      align-items: center;
      gap: 15px;
      font-weight: 500;
    }

    &-counter {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
}

#cardwrapper {
  border: none;
  display: flex;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
}

.infobox {
  display: flex;
  flex: 1;
  justify-content: end;

  &-button-specs {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
    // position: absolute;
    margin-top: 4px;
    height: 23px;
    right: 0;
    padding: 3px;
    border-radius: $radius-l;
    border-style: none;
    background-color: $c-secondary; // babc16
    color: white; //$c-secondary-text;

    &-text {
      font-size: 0.8rem;
      padding: 0px 8px;
      padding-right: 16px;
      font-family: 'Source Sans 3', sans-serif !important;
      font-weight: 400px;
      text-wrap: nowrap;

      @media (max-width: 999px) {
        padding-right: 8px;
      }
    }
  }

  &-question-mark {
    // padding: 5px 10px;
    padding: 0px 5px;
    border-radius: $radius-l;
    font-weight: bold;
    font-size: 0.7rem;    
    color: white;
    background-color: $c-primary;
  }
}





#fullcover {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  // top: 10%;
  left: 50%;
  // width: 30rem;
  // margin-left: -15rem;
  // height: 80vh;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}
// .greyheader {
//   color: $c-secondary;
//   background-color: $c-primary; 
//   border-radius: 5px; 
//   margin: 0px 10px 10px 10px; 
//   font-size: x-large;
//   text-align: center; 
// }

.imagescroller {
  // max-height: calc(85% - 1px); // a trick to force a scroll area to appear despite fixed position
  max-height: calc(98%); // minus size of modaltopcontainer
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  // margin-left: auto;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  // padding: 0px 10px 0px 10px;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

</style>